<template>
  <div class="Settings px-12 py-8">
    <div class="Settings-buttonContainer mb-12">
      <v-btn
        active-class="Settings-button--active"
        class="Settings-button"
        depressed
        exact
        tile
        :to="{ name: 'ShopSettings' }"
      >
        {{ $t('settings.tabName.shop') }}
      </v-btn>
      <v-btn
        active-class="Settings-button--active"
        class="Settings-button"
        depressed
        exact
        tile
        :to="{ name: 'ServicesSettings' }"
      >
        {{ $t('settings.tabName.services') }}
      </v-btn>
      <v-btn
        active-class="Settings-button--active"
        class="Settings-button"
        depressed
        exact
        tile
        :to="{ name: 'CalendarSettings' }"
      >
        {{ $t('settings.tabName.calendar') }}
      </v-btn>
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Settings',

  data() {
    return {
      tab: 'shop'
    }
  }
}
</script>

<style lang="scss">
.Settings {
  max-width: 1200px;
}
.Settings-button {
  padding: 0.4em 3.5em !important;
  background-color: var(--v-secondary-lighten2) !important;
  color: darken(white, 40) !important;
  &:hover {
    background-color: white;
  }
  &:focus {
    outline: none;
  }
  &--active {
    border-bottom: 2px solid var(--v-secondary-base);
    background-color: white;
    font-weight: 600;
    color: var(--v-secondary-base) !important;
  }
}

.App-galileo .Settings-button {
  background-color: #e4e8ec !important;
  &--active {
    border-bottom: 2px solid var(--v-primary-base);
    background-color: white !important;

    &::before {
      display: none;
    }
  }
}
</style>
